import { all, spawn, put } from 'saga-query';
import { locale, loadMessages } from 'devextreme/localization';
import { resetStoreSaga } from '@app/state/resetStore';
import roMessages from '@app/locales/devex.ro.json';
import { uiListReportsSaga } from '@app/state/insider/once';
// import { watchStateIitialization } from '@app/state/insider/ui/invoiceTrack';
// import { fetchMonede } from '@app/state/insider/currencyDomain';
function* start() {
  const now = new Date();
  const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
  const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

  yield console.log(
    `Softwiz Creation \u00A9 ${new Date().getFullYear()}| JurnalGold | run. ${formattedDate} ${formattedTime} | ${
      process.env.NODE_ENV
    }`
  );
  //(!)// do not change, see prebuild script //(!)//
  yield console.log('JGAP build id: 261/2026-08-19 03:02:48')
}

export default function* rootSaga() {
  yield* all([
    spawn(start),
    spawn(resetStoreSaga),
    spawn(loadMessages, roMessages),
    spawn(locale, 'ro'),
    spawn(uiListReportsSaga),
    // spawn(watchStateIitialization),
  ]);
}
